import React from 'react';
import Header from './../../inc/Header';
import Footer from './../../inc/Footer';
import Loader from './../../inc/Loader';
import Menu from './../../inc/Menu';
import MenuToggleBtn from './../../inc/MenuToggleBtn';

import Hero from './Hero';
import ProjectInfo from './ProjectInfo';
import ProjectInfoModal from './ProjectInfoModal';
import VimeoVideo from './VimeoVideo';
import Image from './Image';
import ImageHalf from './ImageHalf';
import Quote from './Quote';
import NewLayouts from './../Marmalade/NewLayouts';


import Carousel from './Carousel';
import DrawingSlider from './DrawingSlider';
import RelatedProjects from './RelatedProjects';

import ScrollToTop from './../../inc/ScrollToTop';


import img_l1 from './../../../assets/img/projects/marmalade/l1.jpg';
import img_l2 from './../../../assets/img/projects/marmalade/l2.jpg';
import img_l3 from './../../../assets/img/projects/marmalade/l3.jpg';
import img_l4 from './../../../assets/img/projects/marmalade/l4.jpg';
import img_l5 from './../../../assets/img/projects/marmalade/l5.jpg';
import img_l6 from './../../../assets/img/projects/marmalade/l6.jpg';
import img_l7 from './../../../assets/img/projects/marmalade/l7.jpg';

import img_s0 from './../../../assets/img/projects/marmalade/s0.jpg';
import img_s1 from './../../../assets/img/projects/marmalade/s1.jpg';
import img_s2 from './../../../assets/img/projects/marmalade/s2.jpg';



class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
	}
	componentDidMount() {
		let _this = this;
		setTimeout(() => {
			this.setState({
				pageLoading: false
			})
		},1000)
		
	}

	render() {
		let _this = this;
		let { menu } = this.props.menu;
	
		// const Fullpage = () => (
		// 	<ReactFullpage
		// 		pluginWrapper={molePluginWrapper}
		// 		//scrollHorizontally={true}
		// 		//scrollHorizontallyKey={process.env.REACT_APP_HORIZONTAL_SCROLL_LICENSE}
		// 		scrollOverflow={true}
		// 		scrollOverflowReset={true}
		// 		licenseKey={process.env.REACT_APP_FULLPAGE_LICENSE}
		// 		offsetSections={true}
		// 		responsiveWidth={process.env.REACT_APP_FULLPAGE_BREAKPOINT}
		// 		scrollingSpeed={500}
		// 		css3={true}
		// 		// responsiveSlides={true}
		// 		normalScrollElements='.normal-scroll-elem'
		// 		controlArrows={false}
		// 		afterLoad={
        //             function (origin, destination, direction) {
		// 				let logo = document.querySelector('.mole-logo');
		// 				let pTitle = document.querySelector('.mole__project-details .project-title');
		// 				let rTitle = document.querySelector('.mole__related-projects .--title');

		// 				if(!destination.isFirst){
		// 					pTitle.style['top'] = 'var(--gutterY)';
		// 					pTitle.classList.remove('c-white');
		// 					logo.classList.add('hidden');
		// 				}
		// 				else{
		// 					pTitle.removeAttribute('style');
		// 					pTitle.classList.add('c-white');
		// 					logo.classList.remove('hidden');
		// 				}

		// 				if(destination.isLast){
		// 					pTitle.classList.add('hidden');
		// 					logo.classList.remove('hidden');
		// 				}
		// 				else{
		// 					pTitle.classList.remove('hidden');
		// 				}

		// 				if(destination.item.querySelector('.mole__related-projects')){
		// 					pTitle.classList.add('hidden')
		// 					rTitle.classList.remove('hidden');
		// 				}
		// 				else{
		// 					rTitle.classList.add('hidden');
		// 				}
        //             }
        //         }
        //         onLeave={
        //             function (origin, destination, direction) {
		// 				let logo = document.querySelector('.mole-logo');
		// 				let pTitle = document.querySelector('.mole__project-details .project-title');
		// 				let rTitle = document.querySelector('.mole__related-projects .--title');

		// 				if(!destination.isFirst){
		// 					pTitle.style['top'] = 'var(--gutterY)';
		// 					pTitle.classList.remove('c-white');
		// 					logo.classList.add('hidden');
		// 				}
		// 				else{
		// 					pTitle.removeAttribute('style');
		// 					pTitle.classList.add('c-white');
		// 					logo.classList.remove('hidden');
		// 				}

		// 				if(destination.isLast){
		// 					pTitle.classList.add('hidden');
		// 					logo.classList.remove('hidden');
		// 				}
		// 				else{
		// 					pTitle.classList.remove('hidden');
		// 				}

		// 				// if(destination.item.querySelector('.mole__related-projects')){
		// 				// 	pTitle.classList.add('hidden')
		// 				// 	rTitle.classList.remove('hidden');
		// 				// }
		// 				// else{
		// 				// 	pTitle.classList.remove('hidden');
		// 				// 	rTitle.classList.add('hidden')
		// 				// }

		// 				// hide slide prev btn
		// 				let slideP = destination.item.querySelector('.fp-prev');
		// 				let slideL = destination.item.querySelector('.fp-next');
		// 				if(slideP) { slideP.classList.add('disabled') }

		// 				if(slideL){
		// 					if(slideL.classList.contains('disabled')){
		// 						slideP.classList.remove('disabled');
		// 					}
		// 				}
        //             }
		// 		}
		// 		afterSlideLoad={
		// 			function(section, origin, destination, direction){
		// 				let slideP = destination.item.closest('section').querySelector('.fp-prev');
		// 				let slideL = destination.item.closest('section').querySelector('.fp-next');

		// 				(destination.isFirst) ? slideP.classList.add('disabled') : slideP.classList.remove('disabled');
		// 				(destination.isLast) ? slideL.classList.add('disabled') : slideL.classList.remove('disabled');
		// 			}
		// 		}
		// 		render={({ state, fullpageApi }) => {
		// 			return (
		// 				<ReactFullpage.Wrapper>
							
		// 				</ReactFullpage.Wrapper>
		// 			)
		// 		}}
		// 	/>
		// );
		return (
			<React.Fragment>
				<main className="mole__project-details">
					<Hero/>
					<ProjectInfo {..._this.props}/>
					<ImageHalf {..._this.props}
						align ='right' 
						imgsrc = {img_s0}
					/>
					{/* <Image {..._this.props}
						imgsrc = {img_l1}
					/> */}
					<VimeoVideo {..._this.props}
						id = {580243343}
					/>
					<Quote {..._this.props}
						align ='right' 
						quote ='Marmalade Lane is a delightful triumph <br/> in many ways: a single development of individual homes managing to be intimate, characterful, light, airy and civic -and clearly cherished by those seeking more.'
						author ='Olivia Tusinski, Architecture Today'	
					/>
					<Image {..._this.props}
						imgsrc = {img_l2}
					/>
					<Image {..._this.props}
						imgsrc = {img_l3}
					/>
					<ImageHalf {..._this.props}
						imgsrc = {img_s1}
					/>
					<Image {..._this.props}
						imgsrc = {img_l4}
					/>
					<Quote {..._this.props}
						quote ='Mole have been central to the vision,
						planning and realisation of this unique
						project from start to finish. The result is
						that an unusual and potentially daunting
						development process has run more
						smoothly than would ever have been
						expected'
						author ='Neil Murphy, TOWN'	
					/>
					<Image {..._this.props}
						imgsrc = {img_l5}
					/>
					<ImageHalf {..._this.props}
						align ='right'
						imgsrc = {img_s2}
					/>
					<Image {..._this.props}
						imgsrc = {img_l6}
					/>
					
					<Carousel {..._this.props}/>
					
					<NewLayouts {..._this.props}/>
					<DrawingSlider {..._this.props}/>
					<RelatedProjects/>
					
					<ProjectInfoModal/>

					<NewLayouts/>
				</main>
			</React.Fragment>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Projects/Details/_index.js